import { render } from "./TgToggle.vue?vue&type=template&id=25e1f820&scoped=true&ts=true"
import script from "./TgToggle.vue?vue&type=script&lang=ts"
export * from "./TgToggle.vue?vue&type=script&lang=ts"

import "./TgToggle.vue?vue&type=style&index=0&id=25e1f820&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e1f820"]])

export default __exports__